export default __webpack_public_path__ + "static/media/loading.7ac311d0.gif";